import { ReactNode, useState } from "react";

/**
 * A lender's logo, or `fallback` when it has none or the image fails to load
 * (the hourly lender mirror can serve a removed logo's URL for up to an hour).
 */
export const LenderLogo = ({
  src,
  alt,
  className,
  fallback
}: {
  src: string | null;
  alt: string;
  className?: string;
  fallback: ReactNode;
}) => {
  // Remember which src failed, so a new src gets a fresh try.
  const [failedSrc, setFailedSrc] = useState<string>();
  return src && src !== failedSrc ? (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailedSrc(src)}
    />
  ) : (
    fallback
  );
};
